import {ensureRankersNamespace, RankersNamespaceKey} from "./rankers_namespace";

// Keys for the server-injected RequestContext entity values on the Rankers namespace.
// The server sets these in _head.html.erb from its authoritative RequestContext
// (host + URI based — see app/view_models/request_context.rb). Unlike the user-agent
// value, entity is a function of host + URI, which is the page-cache key, so the
// injected value is cache-stable per URL and does NOT suffer the staleness problem
// that getRankersUserAgent() guards against.
export const RankersEntityTypeCodeKey = 'RankersEntityTypeCode';
export const RankersEntityCodeKey = 'RankersEntityCode';

/**
 * Set the RequestContext entity values on the global window namespace.
 * Called once per page load from _head.html.erb with server-rendered values.
 *
 * @param {string} typeCode - entity type code, e.g. "RANKERS_WEBSITE" / "ONLINE_APP" / "NATIVE_APP"
 *   (the entity's preconfig type_code — an online web app is "ONLINE_APP", not "WEB_APP")
 * @param {string} code - the specific entity code (RankersWebsite / OnlineApp / NativeApp code)
 */
export function setRankersEntity(typeCode, code) {
    ensureRankersNamespace();
    window[RankersNamespaceKey][RankersEntityTypeCodeKey] = typeCode || "";
    window[RankersNamespaceKey][RankersEntityCodeKey] = code || "";
}

/**
 * Retrieve the server-injected entity type code (e.g. "ONLINE_APP").
 * @returns {string} the entity type code, or "" when not set.
 */
export function getRankersEntityTypeCode() {
    if (!window[RankersNamespaceKey]) return "";
    return window[RankersNamespaceKey][RankersEntityTypeCodeKey] || "";
}

/**
 * Retrieve the server-injected entity code.
 * @returns {string} the entity code, or "" when not set.
 */
export function getRankersEntityCode() {
    if (!window[RankersNamespaceKey]) return "";
    return window[RankersNamespaceKey][RankersEntityCodeKey] || "";
}
